(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[210],{

/***/ "JxsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/widgets/happy-to-care/HappyToCare.jsx












var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */













var mainBlockStyles = {
  default: {
    maxHeight: 'min(calc(300rem / 16), 100vw)',
    maxWidth: '320px'
  },
  large: {
    maxHeight: 'min(calc(300rem / 16), 100vw)',
    maxWidth: '700px'
  }
};
var titleStyles = {
  minHeight: 'calc(52rem / 16)'
};
var sliderContainerStyles = {
  margin: '0 calc(-1 * ((100vw - min(320px, calc(100vw - 30px))) / 2 + 20px))',
  padding: '0 calc((100vw - min(320px, calc(100vw - 30px))) / 2 + 15px)' // I plead guilty for layout crimes, put me in jail ASAP

};

var HappyToCare_getSlideItem = function getSlideItem(item, index, hasTwoItems) {
  return __jsx("div", {
    style: hasTwoItems ? {
      maxWidth: 'calc(380rem / 16)'
    } : {
      maxWidth: 'calc(360rem / 16)'
    },
    className: classnames_default()('px-5 md:p-0 text-black mx-auto lg:w-full leading-tight', {
      'order-first': hasTwoItems && index === 0,
      'lg:mt-80': hasTwoItems
    }),
    key: item.title
  }, item.imageUrl && __jsx(Image["b" /* default */], {
    imageUrl: item.imageUrl,
    ratioKey: ratios_utils["c" /* default */].XL,
    className: "rounded overflow-hidden"
  }), __jsx("div", {
    className: "font-bold pt-15 text-16"
  }, item.title), __jsx("div", {
    className: "leading-normal pt-10 text-14"
  }, item.description));
};

var HappyToCare_getSeeMoreButton = function getSeeMoreButton(url, hasTwoItems, isTablet) {
  return __jsx(TrackClick["a" /* TrackClick */], {
    as: url ? DynamicLink["a" /* default */] : 'div',
    className: classnames_default()('flex mt-auto flex-col items-center text-center text-12', {
      'text-happyToCare hocus:text-happyToCare-active active:text-happyToCare-active': !hasTwoItems && isTablet || !isTablet,
      'text-ultramarine': hasTwoItems && isTablet
    }),
    target: "_blank",
    trackingData: url ? {
      actionGA: 'happyToCare_Info',
      labelGA: 'Cta_SeeMore_happyToCare'
    } : undefined,
    url: url
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].NEEDLE,
    width: "calc(30rem / 16)"
  }), !!url && __jsx("span", {
    className: "underline",
    "data-testid": "HTCLink"
  }, Object(i18n["h" /* t */])('common.seeMore')));
};

var Background = function Background() {
  var style = {
    overflow: 'visible'
  };
  return __jsx("svg", {
    className: "overflow-visible lg:mt-50 shrink-0 -z-1",
    viewBox: "0 0 680 680",
    width: 460,
    height: 460,
    style: style
  }, __jsx("path", {
    fill: "#F7F7F7",
    d: "M172 339c0 5-49 14-83 13-35 0-89-10-89-15s53-13 88-13c36 1 84 9 84 15m55 226c14-32 41-72 46-70 4 2-6 50-20 81s-45 76-50 75c-5-2 9-53 24-86Zm-49-32c21-28 56-61 61-58 4 3-18 47-39 74-20 28-60 65-65 62-4-3 21-50 43-78Zm-40-43c27-22 68-46 72-42s-27 42-54 63c-27 22-74 49-78 45-3-4 32-43 60-66Zm-30-51c32-15 78-29 81-24 2 4-37 34-68 49s-84 30-86 26c-2-5 41-35 73-51Zm-16-56c34-8 82-10 84-6v1c1 5-44 25-78 32-33 8-87 10-89 6l-1-1c-1-5 49-24 84-32Zm218 123c5 1 6 50 0 84-7 34-26 86-31 85s-4-54 3-89c6-36 23-81 28-80m40 3c5 0 17 47 18 82 2 34-5 89-10 89s-16-52-18-87c-2-36 4-84 10-84m150-110c2-5 50 3 82 15s79 40 78 45-54-6-87-18c-33-13-74-37-73-42Zm-18 35c3-4 48 14 77 34 28 19 67 57 65 61v1c-3 4-51-19-81-39-29-19-63-52-61-57Zm-26 30c4-4 44 25 67 50 23 26 53 71 50 76-4 3-46-30-70-56s-50-66-47-70Zm-32 23h1c4-3 36 35 53 65 17 29 35 81 31 84-5 3-38-39-55-70-18-31-34-76-30-79Zm-36 15c5-1 28 42 37 76 10 32 16 86 11 89-5 1-28-47-37-81-10-34-15-81-11-84Zm121-141c1-5 50-9 84-4 34 4 87 20 86 25 0 5-53 7-89 3-35-5-82-19-81-24m0-40c0-5 47-19 81-23s89 0 90 5-51 19-86 23c-36 4-84 0-85-5m65-79c32-12 86-20 88-16 2 5-45 30-78 42-34 12-81 20-83 15s40-30 73-41Zm-29-51c29-19 79-40 82-36h1c2 5-37 40-67 59s-74 38-78 34c-3-4 33-39 62-57Zm-40-43c24-25 68-57 72-54 4 4-27 47-51 73-25 25-63 54-68 51-4-4 23-45 47-70Zm-49-33c18-29 53-70 58-69 5 3-15 52-33 83s-49 67-54 65c-5-3 12-49 29-79Zm-55-20c10-33 36-82 41-81 5 2-3 54-14 89-10 33-32 76-37 75s0-50 10-83ZM364 0c5 0 10 53 7 89-2 36-14 82-19 82s-11-49-9-83c2-35 16-88 21-88m-79 4c5-1 22 49 27 85 6 35 6 83 1 84s-23-45-28-79c-6-34-5-89 0-90m-76 22c4-2 32 43 46 76s25 79 20 82c-5 2-32-39-46-71-13-31-25-85-20-87Zm-69 39c4-3 42 34 63 63 20 29 42 72 38 75s-40-30-61-58c-20-27-44-76-40-80Zm-58 54c3-4 48 23 75 47 27 23 58 60 55 64s-46-20-72-42c-27-23-62-66-58-69Zm-44 65c2-4 52 12 84 29 32 16 70 45 68 50-2 4-49-9-80-25s-75-49-72-54Zm-28 74c1-5 54 0 89 9 34 8 78 27 77 32v1c-1 5-50 2-83-6-34-8-83-30-83-36Z"
  }));
};

var HappyToCare_HappyToCare = function HappyToCare(_ref) {
  var className = _ref.className,
      items = _ref.items,
      title = _ref.title,
      url = _ref.url;

  var getBottomControls = function getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index) {
    return __jsx("div", {
      className: "flex items-center mt-20 justify-center"
    }, __jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-8 ltr:mr-20 rtl:ml-20",
      color: colors["a" /* COLORS */].TRANSPARENT,
      isDisabled: isPreviousControlDisabled,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: onPrevious,
      size: 12,
      theme: "ghost"
    }), __jsx("span", {
      className: "flex justify-center items-baseline text-black text-12"
    }, __jsx("span", {
      className: "text-14 font-bold"
    }, index + 1), "/", items.length), __jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-8 ltr:ml-20 rtl:mr-20",
      isDisabled: isNextControlDisabled,
      color: colors["a" /* COLORS */].TRANSPARENT,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180,
      size: 12,
      theme: "ghost"
    }));
  };

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var hasTwoItems = items.length === 2 || isDesktop;
  var mainBlockTheme = !hasTwoItems && isTablet ? 'large' : 'default';

  var containerStyle = _objectSpread(_objectSpread({}, mainBlockStyles[mainBlockTheme]), isDesktop && !hasTwoItems || !isDesktop ? {
    maxHeight: 'none'
  } : {});

  return __jsx("div", {
    className: classnames_default()(className, 'isolate px-15 lg:p-0 relative lg:flex')
  }, __jsx("div", {
    className: classnames_default()('shrink-0 w-full rounded mx-auto p-20 flex flex-col items-center text-ultramarine', {
      'lg:mx-20': hasTwoItems
    }, {
      'lg:pb-0': !hasTwoItems
    }),
    style: containerStyle
  }, !isTablet ? __jsx("div", {
    className: "absolute left-0 right-0 top-0 -mt-60 flex items-center justify-center overflow-hidden pointer-events-none"
  }, __jsx(Background, null)) : null, __jsx("div", {
    className: "-z-1 mx-15 md:m-0 absolute flex inset-0 items-center justify-center pointer-events-none"
  }, __jsx("div", {
    className: "absolute bg-happyToCare inset-x-0 flex items-center justify-center mx-auto rounded top-0 w-full h-full",
    style: mainBlockStyles[mainBlockTheme]
  }, isTablet ? __jsx(Background, null) : null)), __jsx(Icon["a" /* Icon */], {
    className: "mb-15 lg:my-15 shrink-0",
    name: icons["a" /* ICONS */].HAPPY_TO_CARE_TEXT,
    width: isTablet ? 'calc(110rem / 16)' : 'calc(100rem / 16)'
  }), __jsx("div", {
    className: "font-brand text-24 md:text-28 leading-tight mb-20 flex items-center text-center",
    style: titleStyles
  }, title), !isTablet ? __jsx(react["Fragment"], null, __jsx(SliderHandler["a" /* SliderHandler */], {
    style: sliderContainerStyles,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: 0,
    items: items.map(function (item, index) {
      return HappyToCare_getSlideItem(item, index);
    })
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        index = _ref2.index,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return __jsx("div", {
      className: "flex-1 flex-col flex pb-20 relative"
    }, itemsNode, hasControls && getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index));
  }), HappyToCare_getSeeMoreButton(url, hasTwoItems, isTablet)) : __jsx(react["Fragment"], null, hasTwoItems && HappyToCare_getSeeMoreButton(url, hasTwoItems, isTablet), (!isDesktop || !hasTwoItems) && __jsx("div", {
    className: classnames_default()('flex my-20 w-screen', {
      'justify-between': hasTwoItems,
      'justify-center': !hasTwoItems
    })
  }, items.map(function (item, index) {
    return HappyToCare_getSlideItem(item, index, hasTwoItems);
  })), !hasTwoItems && HappyToCare_getSeeMoreButton(url, hasTwoItems, isTablet))), isDesktop && hasTwoItems && (items.length > 1 ? items : [{
    imageUrl: '',
    title: '',
    description: ''
  }].concat(Object(toConsumableArray["a" /* default */])(items))).map(function (item, index) {
    return HappyToCare_getSlideItem(item, index, hasTwoItems);
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/happy-to-care-line/HappyToCareLine.jsx

var HappyToCareLine_jsx = react_default.a.createElement;




var HappyToCareLine_HappyToCareLine = function HappyToCareLine(_ref) {
  var _businessSocialRespon;

  var id = _ref.id,
      seeMoreLink = _ref.seeMoreLink,
      businessSocialResponsibility = _ref.businessSocialResponsibility;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!(businessSocialResponsibility === null || businessSocialResponsibility === void 0 ? void 0 : (_businessSocialRespon = businessSocialResponsibility.items) === null || _businessSocialRespon === void 0 ? void 0 : _businessSocialRespon.length)) {
    return null;
  }

  return HappyToCareLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "happyToCare",
    id: id,
    isWide: !isTablet
  }, HappyToCareLine_jsx(HappyToCare_HappyToCare, Object(esm_extends["a" /* default */])({}, businessSocialResponsibility, {
    className: "mt-80 md:mt-0",
    url: seeMoreLink
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/happy-to-care/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (HappyToCareLine_HappyToCareLine);

/***/ })

}]);